import { render } from "./Upload.vue?vue&type=template&id=6f55e05b&ts=true"
import script from "./Upload.vue?vue&type=script&lang=ts"
export * from "./Upload.vue?vue&type=script&lang=ts"

import "./Upload.vue?vue&type=style&index=0&id=6f55e05b&lang=css"

import exportComponent from "/codebuild/output/src835202786/src/web-previewer-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__